import { createStructuredSelector } from 'reselect'
import { branch, renderComponent, withHandlers } from 'recompose'

import { isMobile } from 'shared/responsive-helpers'
import { sendAmplitudeEvent, useSendGTAGEvent } from 'analytics/utils'

import { ACTIVE_FORM_LOGIN } from 'header/constants'
import { authVisible } from 'header/actions'
import { selectVehicle } from '@booking/actions'
import { userSelector } from 'auth/selectors'

import VehicleSelection from 'booking/components/flow-steps/VehicleSelection'
import VehicleFormSection from './VehicleFormSection'
import LoginSignUpContainerMobile from './LoginSignUpContainerMobile'
import LoginSignUpContainerDesktop from './LoginSignUpContainerDesktop'

const $LoginSignUpContainerWrapped = ({ onClickLogin, onNext, setVehicle, selectVehicle, analyticsFlowType }) => {
    const [showVehicleForm, setShowVehicleForm] = React.useState(false)
    const sendGTAGEvent = useSendGTAGEvent()

    const guestCheckoutBtnHandler = () => {
        setShowVehicleForm(true)

        if (analyticsFlowType) {
            sendAmplitudeEvent('Guest checkout selected', {
                'Flow Type': analyticsFlowType,
            })
            sendGTAGEvent('guest_checkout_selected', {
                flow_type: analyticsFlowType,
            })
        }
    }

    const onSelectVehicleClick = params => {
        selectVehicle(params)
        if (analyticsFlowType) {
            sendGTAGEvent('select_vehicle', { flow_type: analyticsFlowType })
            sendAmplitudeEvent('Vehicle Selected', { 'Flow Type': analyticsFlowType })
        }
    }

    const loginSignUpComponent = isMobile() ? (
        <LoginSignUpContainerMobile onClickLogin={onClickLogin} guestCheckoutBtnHandler={guestCheckoutBtnHandler} />
    ) : (
        <LoginSignUpContainerDesktop onClickLogin={onClickLogin} guestCheckoutBtnHandler={guestCheckoutBtnHandler} />
    )

    return (
        <>
            {showVehicleForm && (
                <VehicleFormSection onNext={onNext} setVehicle={setVehicle} selectVehicle={onSelectVehicleClick} />
            )}
            {!showVehicleForm && loginSignUpComponent}
        </>
    )
}
const LoginSignUpContainerWrapped = compose(
    connect(null, { authVisible }),
    withHandlers({
        onClickLogin:
            ({ authVisible }) =>
            () => {
                authVisible(ACTIVE_FORM_LOGIN)
            },
    })
)($LoginSignUpContainerWrapped)

const GuestCheckoutVehicleSelection = compose(
    connect(createStructuredSelector({ user: userSelector }), { selectVehicle }),
    withTranslate,
    branch(({ user }) => !user, renderComponent(LoginSignUpContainerWrapped), renderComponent(VehicleSelection))
)(LoginSignUpContainerWrapped)

export default GuestCheckoutVehicleSelection
